import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import tinycolor from "tinycolor2";
import { ColorPicker, Picker, SelectTrigger } from "../../../components/ColorPicker/index.js";
function Color(props) {
  const { id, onChange } = props;
  const color = props.color;
  const [open, onSetOpen] = useState(false);
  const safeColor = convertToHex(color);
  return /* @__PURE__ */ jsx(
    ColorPicker,
    {
      localeText: { triggerSelectLabel: `${id}` },
      onColorChange: (newColor) => onChange?.(id, newColor),
      picker: /* @__PURE__ */ jsx(Picker, {}),
      trigger: {
        Component: SelectTrigger,
        onSetOpen,
        open
      },
      value: safeColor
    }
  );
}
function convertToHex(value) {
  if (value.startsWith("#")) {
    return value;
  }
  const instance = tinycolor(value);
  const hexString = value.startsWith("rgba") ? instance.toHex8() : instance.toHex();
  return `#${hexString}`;
}
export {
  Color
};
//# sourceMappingURL=Color.js.map
